import { StepIconProps } from "@mui/material";

import {
  MilestoneActiveStepperIcon,
  MilestonePaidStepperIcon,
  MilestonePinningStepperIcon,
} from "../../../../../../assets/icons/go-hire-icons";

export const MilestoneStepIcon = ({ completed: paid, active }: StepIconProps) => {
  if (paid) return <MilestonePaidStepperIcon />;
  if (active) return <MilestoneActiveStepperIcon />;

  return <MilestonePinningStepperIcon />;
};
